module.exports = __webpack_public_path__ + "img/培训团建.ba1ceba6.png";